
/**
 * Fetches similar properties codes from our local backend API.
 * @param propertyCode The code of the property being viewed.
 * @returns A list of similar property codes.
 */
export const getSimilarPropertiesCodes = async (propertyCode: string): Promise<string[]> => {
  try {
    const response = await fetch("/api/similar-properties/substitutes", {
      method: "POST",
      body: JSON.stringify({ codigo: propertyCode }),
      headers: {
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Network response was not ok: ${response.status}`);
    }

    const result = await response.json();
    return result?.codes || [];
  } catch (error) {
    console.error("Error fetching similar properties codes from backend:", error);
    return [];
  }
};
